import angular from 'angular';
import constants from 'app/constants';
import {
  praDataService,
  loaderService,
  ssDialogService,
  userService,
  orgDataService,
  praSharedModelService,
  riskSharedModelService,
  assetSharedModelService,
} from 'app/services';

import {
  alerts,
  helpTooltip,
  convertToNumber,
  appReports,
} from 'app/components/global';

import addPraAssessmentDialog from './assessments/dialog.addAssessmentDialog';
import praSettingsDialog from './dialog.settingsDialog';
import assessments from './assessments';
import controller from './pra.controller';


export const routeConfig = {
  template: require('./pra.html'),
  controller: 'PRAController',
  controllerAs: 'praVM',
};

export default angular.module('app.components.advisory.pra', [
  addPraAssessmentDialog,
  alerts,
  appReports,
  assessments,
  praDataService,
  constants,
  convertToNumber,
  helpTooltip,
  loaderService,
  praSettingsDialog,
  ssDialogService,
  userService,
  orgDataService,
  praSharedModelService,
  riskSharedModelService,
  assetSharedModelService,
])
  .controller('PRAController', controller)
  .name;

console.log('app.components.advisory.pra created');
